module.exports = __webpack_public_path__ + "static/media/AviorsysNew.c1ca0dc0.jpg";